import { SafetyInfoDocumentModel } from "@/api/mappers/safetyInfoDocument.mapper";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

export type SafetyDocumentListProps = {
    documents: Array<SafetyInfoDocumentModel>;
};

const SafetyDocumentList = ({ documents = [] }: SafetyDocumentListProps) => {
    const { t } = useGranite();

    if (documents.length === 0) {
        return null;
    }

    return (
        <div className="mt-2 float-left mr-4">
            <div>{t("productSafetyInfo.documentList.title")}</div>
            <ul className="safety-info-document__list">
                {documents.map((doc) => (
                    <li key={doc.type}>
                        <a
                            className="ml-2"
                            href={doc.url}
                            data-test={`safetyinfo-document-list-${doc.type}`}
                        >
                            {t(`productSafetyInfo.document.type.${doc.type}`)}
                        </a>
                        <i className="las la-file-pdf ml-2"></i>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export { SafetyDocumentList };
